import Link from 'next/link';
import React from 'react';
import { GetAllBlogPostResult } from '@/sanity.types';
import Image from 'next/image';
import { urlForImage } from '@/sanity/lib/utils';

interface BlogComponentProps {
  src:
    | GetAllBlogPostResult[0]['coverMedia']['coverImage']
    | GetAllBlogPostResult[0]['coverMedia']['coverVideo'];
  title: string;
  alt: string;
  href: string;
  summary: string;
  blurDataURL: string;
}

export default function BlogTile({
  src,
  title,
  href,
  summary,
  blurDataURL,
}: BlogComponentProps) {
  return (
    <div
      className="blogTile"
      role="article"
      aria-labelledby={`blog-title-${title}`}
    >
      <Link href={href} aria-label={`Read more about ${title}`}>
        <Image
          src={
            (urlForImage(src)?.url() as string) || '/n_images/default-blog.jpg'
          }
          alt={title}
          width={300}
          height={250}
          quality={100}
          sizes="(max-width: 767px) 100vw, 30vw"
          role="img"
          aria-hidden="true"
          placeholder="blur"
          blurDataURL={blurDataURL}
        />
      </Link>
      <div className="blogTileContent">
        <Link
          href={href}
          id={`blog-title-${title}`}
          aria-label={`Read the article: ${title}`}
        >
          <h3>{title}</h3>
        </Link>
        <p>{summary}</p>
      </div>
    </div>
  );
}
